import { useState } from 'react'
import { Popover, Checkbox, Input, Tooltip, Button } from 'antd'
import { GiftOutlined, GiftFilled } from '@ant-design/icons'
import { MarkAnchor, MarkTrigger, MarkContent, MarkActions } from './styles'

const PromotionalPackageMark = mediaProps => {
  const {
    answerId,
    questionId,
    enrollmentId,
    productId,
    typeOfQuestion,
    url,
    clientSubmission,
    promotionalPackage,
    promotionalComment = '',
    onSaveMediaMark,
    tooltipTitle = 'This product has active promotional package'
  } = mediaProps
  const [popoverVisible, setPopoverVisible] = useState(false)
  const [draftActive, setDraftActive] = useState(!!promotionalPackage)
  const [draftComment, setDraftComment] = useState(promotionalComment)

  const handleVisibleChange = visible => {
    if (visible) {
      setDraftActive(!!promotionalPackage)
      setDraftComment(promotionalComment || '')
    }
    setPopoverVisible(visible)
  }

  const handleActiveChange = e => {
    const checked = e.target.checked
    setDraftActive(checked)
    if (!checked) {
      setDraftComment('')
    }
  }

  const handleSave = () => {
    onSaveMediaMark({
      answerId,
      questionId,
      enrollmentId,
      productId,
      typeOfQuestion,
      url,
      clientSubmission: !!clientSubmission,
      promotionalPackage: draftActive,
      promotionalComment: draftActive ? draftComment : ''
    })
    setPopoverVisible(false)
  }

  return (
    <MarkAnchor>
      <Popover
        trigger='click'
        placement='bottomLeft'
        autoAdjustOverflow={false}
        getPopupContainer={trigger => trigger.closest('.ant-modal-body')}
        destroyTooltipOnHide
        visible={popoverVisible}
        onVisibleChange={handleVisibleChange}
        content={
          <MarkContent>
            <Checkbox checked={draftActive} onChange={handleActiveChange}>
              Promotional package
            </Checkbox>
            <Input.TextArea
              value={draftComment}
              onChange={e => setDraftComment(e.target.value)}
              placeholder='Comment'
              rows={3}
              maxLength={200}
              disabled={!draftActive}
            />
            <MarkActions>
              <Button type='primary' size='small' onClick={handleSave}>
                Save
              </Button>
            </MarkActions>
          </MarkContent>
        }
      >
        <Tooltip title={tooltipTitle}>
          <MarkTrigger className={promotionalPackage ? 'marked' : undefined}>
            {promotionalPackage ? <GiftFilled /> : <GiftOutlined />}
          </MarkTrigger>
        </Tooltip>
      </Popover>
    </MarkAnchor>
  )
}

export default PromotionalPackageMark
